const APP_NAME = "Data Analyst";
const WELCOME_MESSAGE = "¡Bienvenido! Soy su analista de datos y puedo ayudarte a obtener información valiosa.";

// ********* Dev - PROD ****************
//const AGENT_ID = "EWRYYWXCTC";
//const AGENT_ALIAS_ID = "SJXEMYCLKX";

// ********** QA ***********************
const AGENT_ID = "Y7LCJEHOQF";
const AGENT_ALIAS_ID = "NEUYYKSRUD";

const QUESTION_ANSWERS_TABLE_NAME = "WHISPERBI_QUESTION_ANSWER_RESPONSE";

const AWS_REGION = "";

const MAX_LENGTH_INPUT_SEARCH = 2000;

//***************************************** */
const DB_CONNECTIONS_TABLE_NAME = "WHISPERBI_SOURCE_CONNECTIONS"

const ONBOARDING_ENABLED = "true";

// Gate bloqueante de LayoutApp.js que fuerza a configurar MFA cuando
// account.security.mfa_required es true -- mismo criterio que
// ONBOARDING_ENABLED, permite desactivar el gate sin revertir código.
const MFA_GATE_ENABLED = "true";

const BACKEND_AGENTS_API = "https://4uo9o094s8.execute-api.us-east-1.amazonaws.com/Prod";

// API WebSocket de agentes (output AgentsWebSocketUrl del stack
// whisperbi-agent-management-strands). Sin el límite de 29 s de
// POST /agent/invoke; si queda vacío, el chat usa el HTTP (ver
// api/InvokeAgentAPI.js).
const WEBSOCKET_AGENTS_URL = "wss://kc6aobi533.execute-api.us-east-1.amazonaws.com/Prod";

const BACKEND_SEMANTIC_DATABASE_API = "https://s0clqj4j09.execute-api.us-east-1.amazonaws.com/Prod/semantic-database";

const BACKEND_SEMANTIC_MODEL_API = "https://s0clqj4j09.execute-api.us-east-1.amazonaws.com/Prod";

const BACKEND_SEMANTIC_WORKSPACES_API = "https://s0clqj4j09.execute-api.us-east-1.amazonaws.com/Prod/semantic-workspaces";

// Módulo Catálogo Iceberg S3 (Fase 1) -- mismo stack/API Gateway que el
// resto de whisperbi-back-semantic-model, rutas nuevas nada más.
const BACKEND_ICEBERG_DATABASES_API = "https://s0clqj4j09.execute-api.us-east-1.amazonaws.com/Prod/iceberg-databases";

const BACKEND_ICEBERG_SCHEMAS_API = "https://s0clqj4j09.execute-api.us-east-1.amazonaws.com/Prod/iceberg-schemas";

const BACKEND_ICEBERG_TABLES_API = "https://s0clqj4j09.execute-api.us-east-1.amazonaws.com/Prod/iceberg-tables";

const WHISPERBI_SECURITY_API = "https://jwdlzt0gr0.execute-api.us-east-1.amazonaws.com/dev";

const CREDITS_ENGINE_API = "https://fqncv7mxge.execute-api.us-east-1.amazonaws.com/v1";

// Backend de ayuda contextual (whisperbi-backend-contextual-help), stack
// desplegado en la cuenta 908532959026/us-east-1 el 2026-09-22.
const BACKEND_CONTEXTUAL_HELP_API = "https://tdnbzy95ea.execute-api.us-east-1.amazonaws.com/v1";

// Clave PUBLICABLE de Stripe -- segura de exponer en el cliente por diseño
// (a diferencia de la clave secreta, que solo vive en el backend). El
// flujo de upgrade de esta app usa Stripe Checkout/Portal por redirect
// (el backend ya devuelve la URL de la sesión), así que esta constante no
// es estrictamente necesaria hoy -- no agregar @stripe/stripe-js ni
// inicializar Stripe.js en el cliente basándose en esta clave a menos que
// se agregue un flujo con Stripe Elements embebido más adelante. Se deja
// documentada acá para ese eventual uso futuro.
const STRIPE_PUBLISHABLE_KEY = "pk_test_REEMPLAZAR_CON_TU_CLAVE_PUBLICABLE";



const LANGUAGES_QUESTIONS = [
   [ // Spanish
   "¡Hola!",
   "¿Cuántas instalaciones nuevas hay al día de hoy?",
   "¿Cuántas instalaciones nuevas hay en este año?",
   "¿Cuántas instalaciones nuevas hay en comparación con el año anterior?",
   "Dame las 10 plazas con más instalaciones nuevas",
   "¿Cuál es el top 10 de regiones con el mayor número de activaciones?",
   "¿Cuál es la distribución de las activaciones por sistema origen?",
   "¿Cuál es la distribución de las reconexiones por sistema origen?",
   "¿En qué regiones hemos logrado reducir significativamente las cancelaciones involuntarias este mes en comparación con el mes anterior?",
   "¿Cuantas RGUs hay al dia de ayer?",
   "¿Cuantos suscriptores hay a la fecha?",
   "¿Cuales son los 10 plazas con más suscriptores?",
   "¿Cuales son los 10 plazas con menos suscriptores?",
   "¿Cual es la plaza con más suscriptores?",
   "¿Cual es la plaza con menos suscriptores?",
   "¿Cómo varía el número de suscriptores a lo largo del tiempo (diario, mensual, anual)?",
   "¿Cuál es la tasa de crecimiento de suscriptores de un mes a otro?",
   "¿Existen picos o caídas significativas en la cantidad de suscriptores durante ciertos períodos?",
   "¿Cómo varía el número de suscriptores según el tipo de tecnología?",
   "¿Hay una mayor adopción de tecnologías específicas entre los suscriptores?",
   "¿Cómo influye la segmentación de clientes en el número de suscriptores?",
   "¿Cuál es el segmento con más suscriptores?"
   ]
];

const CHART_PROMPT = '\n\
Create detailed ApexCharts.js configurations based on the information provided to support the answer. Focus on meaningful data analysis and visually appealing charts.\n\
\n\
Input Data:\n\
\n\
<information>\n\
    <summary>\n\
        <<answer>>\n\
    </summary>\n\
    <data_sources>\n\
        <<data_sources>>\n\
    </data_sources>\n\
</information>\n\
\n\
The following is the only required output format for a Chart:\n\
\n\
<has_chart>1</has_chart>\n\
<chart_type>[bar/line/pie/etc]</chart_type>\n\
<chart_configuration>[JSON validate format with series and options]</chart_configuration>\n\
<caption>[Insightful analysis about the data chart in 20-40 words]</caption>\n\
\n\
If you do not have a chart configuration, use only the following output format:\n\
\n\
<has_chart>0</has_chart>\n\
<rationale>[The reason to do not generate a chart configuration, max 12 words]</rationale>\n\
\n\
- Provide the caption and chart information in the same language as the summary information.\n\
\n\
Chart Requirements:\n\
\n\
   - Provide only 1 chart configuration\n\
   - Use the appropriate chart type based on the data\n\
   - Each chart must include:\n\
      - Complete series and options configuration\n\
\n\
ApexChartsx Technical Specifications:\n\
\n\
    - Provide the formatter function value as a string in double quotes\n\
    - Use standard ApexCharts.js for React.js syntax\n\
    - Format all property names and string values with double quotes\n\
    - Include appropriate titles, subtitles and axis labels\n\
    - Configure for light mode viewing\n\
    - Use default text format styles\n\
    - Format decimal values to two places using formatter functions\n\
    - Use simple JavaScript functions (no moment.js)\n\
\n\
ApexChartsx Rules to Avoid Known Erros:\n\
\n\
   - Do not use Multiple Y Axis for bars, those are not supported.\n\
   - In JSON format, avoid the error: raise JSONDecodeError("Expecting value", s, err.value) from None\n\
   - Do not use \'udenfined\' values\n\
\n\
Example Chart Configurations:\n\
\n\
<ChartExamples>\n\
  <Chart description="Line Basic">\n\
    <type>line</type>\n\
    <configuartion>\n\
{\n\
   "series":[\n\
      {\n\
         "name":"Desktops",\n\
         "data":[\n\
            10,\n\
            41,\n\
            35,\n\
            51,\n\
            49,\n\
            62,\n\
            69,\n\
            91,\n\
            148\n\
         ]\n\
      }\n\
   ],\n\
   "options":{\n\
      "chart":{\n\
         "height":420,\n\
         "type":"line",\n\
         "zoom":{\n\
            "enabled":false\n\
         }\n\
      },\n\
      "dataLabels":{\n\
         "enabled":false\n\
      },\n\
      "stroke":{\n\
         "curve":"straight"\n\
      },\n\
      "title":{\n\
         "text":"Product Trends by Month",\n\
         "align":"left"\n\
      },\n\
      "grid":{\n\
         "row":{\n\
            "colors":[\n\
               "#f3f3f3",\n\
               "transparent"\n\
            ],\n\
            :0.5\n\
         }\n\
      },\n\
      "xaxis":{\n\
         "categories":[\n\
            "Jan",\n\
            "Feb",\n\
            "Mar",\n\
            "Apr",\n\
            "May",\n\
            "Jun",\n\
            "Jul",\n\
            "Aug",\n\
            "Sep"\n\
         ]\n\
      }\n\
   }\n\
}\n\
    </configuartion>\n\
  </Chart>\n\
\n\
  <Chart description="Bar Funnel">\n\
    <type>bar</type>\n\
    <configuartion>\n\
{\n\
   "series":[\n\
      {\n\
         "name":"Funnel Series",\n\
         "data":[\n\
            1380,\n\
            1100,\n\
            990,\n\
            880,\n\
            740,\n\
            548,\n\
            330,\n\
            200\n\
         ]\n\
      }\n\
   ],\n\
   "options":{\n\
      "chart":{\n\
         "type":"bar",\n\
         "height":420,\n\
         "dropShadow":{\n\
            "enabled":true\n\
         }\n\
      },\n\
      "plotOptions":{\n\
         "bar":{\n\
            "borderRadius":0,\n\
            "horizontal":true,\n\
            "barHeight":"80%",\n\
            "isFunnel":true\n\
         }\n\
      },\n\
      "dataLabels":{\n\
         "enabled":true,\n\
         "formatter":"function (val, opt) { return opt.w.globals.labels[opt.dataPointIndex] + \':  \' + val }",\n\
         "dropShadow":{\n\
            "enabled":true\n\
         }\n\
      },\n\
      "title":{\n\
         "text":"Recruitment Funnel",\n\
         "align":"middle"\n\
      },\n\
      "xaxis":{\n\
         "categories":[\n\
            "Sourced",\n\
            "Screened",\n\
            "Assessed",\n\
            "HR Interview",\n\
            "Technical",\n\
            "Verify",\n\
            "Offered",\n\
            "Hired"\n\
         ]\n\
      },\n\
      "legend":{\n\
         "show":false\n\
      }\n\
   }\n\
}\n\
    <configuartion>\n\
  </Chart>\n\
\n\
  <Chart description="Bar Basic">\n\
    <type>bar</type>\n\
    <configuartion>\n\
{\n\
   "series":[\n\
      {\n\
         "data":[\n\
            400,\n\
            430,\n\
            448,\n\
            470,\n\
            540,\n\
            580,\n\
            690,\n\
            1100,\n\
            1200,\n\
            1380\n\
         ]\n\
      }\n\
   ],\n\
   "options":{\n\
      "chart":{\n\
         "type":"bar",\n\
         "height":420\n\
      },\n\
      "plotOptions":{\n\
         "bar":{\n\
            "borderRadius":4,\n\
            "borderRadiusApplication":"end",\n\
            "horizontal":true\n\
         }\n\
      },\n\
      "dataLabels":{\n\
         "enabled":false\n\
      },\n\
      "xaxis":{\n\
         "categories":[\n\
            "South Korea",\n\
            "Canada",\n\
            "United Kingdom",\n\
            "Netherlands",\n\
            "Italy",\n\
            "France",\n\
            "Japan",\n\
            "United States",\n\
            "China",\n\
            "Germany"\n\
         ]\n\
      }\n\
   }\n\
}\n\
    <configuartion>\n\
  </Chart>\n\
\n\
  <Chart description="Simple Pie">\n\
    <type>pie</type>\n\
    <configuartion>\n\
{\n\
  "series": [2077, 1036.75, 384.99, 277.49],\n\
  "options": {\n\
    "chart": {\n\
      "type": "pie",\n\
      "height": 420\n\
    },\n\
    "labels": ["North America", "Europe", "Other Regions", "Japan"],\n\
    "title": {\n\
      "text": "Video Game Sales Distribution by Region (2000-2010)",\n\
      "align": "center"\n\
    },\n\
    "subtitle": {\n\
      "text": "Total Global Sales: 3,779.72 million units",\n\
      "align": "center"\n\
    },\n\
    "dataLabels": {\n\
      "enabled": true,\n\
      "formatter": "function (val, opt) { return opt.w.config.labels[opt.seriesIndex] + \': \' + val.toFixed(2) + \'%\' }"\n\
    },\n\
    "legend": {\n\
      "position": "bottom"\n\
    },\n\
    "colors": ["#008FFB", "#00E396", "#FEB019", "#FF4560"]\n\
  }\n\
}\n\
    <configuartion>\n\
  </Chart>\n\
\n\
</ChartExamples>';

export { AGENT_ID,
    AGENT_ALIAS_ID,
    LANGUAGES_QUESTIONS,
    CHART_PROMPT,
    QUESTION_ANSWERS_TABLE_NAME,
    APP_NAME,
    WELCOME_MESSAGE,
    MAX_LENGTH_INPUT_SEARCH,
    AWS_REGION,
    DB_CONNECTIONS_TABLE_NAME,
    MFA_GATE_ENABLED,
    ONBOARDING_ENABLED,
    BACKEND_AGENTS_API,
    WEBSOCKET_AGENTS_URL,
    BACKEND_SEMANTIC_DATABASE_API,
    BACKEND_SEMANTIC_MODEL_API,
    BACKEND_SEMANTIC_WORKSPACES_API,
    BACKEND_ICEBERG_DATABASES_API,
    BACKEND_ICEBERG_SCHEMAS_API,
    BACKEND_ICEBERG_TABLES_API,
    WHISPERBI_SECURITY_API,
    CREDITS_ENGINE_API,
    BACKEND_CONTEXTUAL_HELP_API,
    STRIPE_PUBLISHABLE_KEY
};
